import EducationCard from "./EducationCard";
import Section from "../common/Section"
const EducationSection = () => {
  return (
    <Section
      id="projects"
      title="Education"
      subtitle="Recent projects upon which I have worked on."
      className="relative"
    >
      <div className="flex flex-col md:flex-row gap-5 z-20 px-3 md:px-24 2xl:px-[32rem] mt-5 md:mt-0 md:pb-5">
        <EducationCard
          title="Williams College"
          description="Bachelor of Arts in Computer Science"
          date="8/2010 - 03/2014"
        />
      </div>
    </Section>
  );
};
export default EducationSection;
